<script setup lang="ts">
const emit = defineEmits<{
  contactUs: []
}>()

const { t } = useI18n()
const { supportPortal } = useLinks()
</script>

<template>
  <UiDropdownMenuItem
    icon-leading="docue:message-chat-circle"
    @click="emit('contactUs')"
  >
    {{ t('contact-us') }}
  </UiDropdownMenuItem>
  <UiDropdownMenuItem
    v-if="supportPortal"
    as="a"
    :href="supportPortal"
    target="_blank"
    rel="noopener noreferrer"
    icon-leading="docue:book-open-01"
  >
    {{ t('user-menu.link.documentation') }}
  </UiDropdownMenuItem>
</template>
